module.exports = __webpack_public_path__ + "static/media/Close.2511f11c.svg";